import { GETAPPROVERSLIST_SUCCESS, GETAPPROVERSLIST_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getApproversListReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETAPPROVERSLIST_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETAPPROVERSLIST_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getApproversListReducer;
